package com.exura.features.plandefinition.domain.builder.plan

import com.exura.features.plandefinition.domain.model.plan.PlanType
import com.exura.features.plandefinition.domain.model.plan.PreparationPlan

/**
 * Enhanced Preparation Plan Builder - minimal implementation, base class does all the work
 */
class PreparationPlanBuilderNew : BasePlanBuilderNew<PreparationPlan>(planType = PlanType.PREPLAN) {

    override fun build(): PreparationPlan {
        return PreparationPlan(
            firebaseDocId = firebaseDocId(),
            title = title() ?: "",
            description = description() ?: "",
            collections = collections(),
            directSeries = directSeries(),
            imageUrl = imageUrl()
        )
    }
}

fun PreparationPlan.toBuilder(): PreparationPlanBuilderNew {
    val plan = this
    return PreparationPlanBuilderNew().apply {
        setFirebaseDocId(plan.firebaseDocId)
        setTitle(plan.title)
        setDescription(plan.description)
        setCollections(plan.collections)
        setDirectSeries(plan.directSeries)
        setImageUrl(plan.imageUrl)
        markSaved()
    }
}
